'use client'

import { useShellTranslation } from '@/lib/shell/use-shell-translation'
import { cn } from '@/lib/utils'

/**
 * The 401 state on the sign-in page: the person was sent here from a page
 * because their session had lapsed (or they were not signed in yet). It takes
 * the place of the brand header above the sign-in card — one heading and one
 * sentence — and leaves the form below it exactly as it is. The heading is the
 * page's h1, as the brand name is on a plain visit.
 *
 * No 401 picture here (owner, 2026-10-07): above the form it pushed the page
 * past the window, and html/body never scroll (globals.css), so the form was
 * cut off. The status pages inside the app keep their artwork.
 */
export function SessionEndedNotice({ className }: { className?: string }) {
  const { t } = useShellTranslation()
  return (
    <div data-testid="session-ended-notice" className={cn('flex flex-col items-center text-center', className)}>
      <h1 className="text-balance text-xl font-semibold tracking-tight sm:text-2xl">
        {t('shell.status.401.title')}
      </h1>
      <p className="mt-2 max-w-sm text-pretty text-sm leading-relaxed text-muted-foreground">
        {t('shell.status.401.body')}
      </p>
    </div>
  )
}
